
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd","stroke":"#171C26","stroke-width":"2","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M30.11 3.5l-7.883 4.367v4.99l7.884 4.367V3.5zM22.227 17.219c0 1.378-1.087 2.495-2.426 2.495H3.426C2.086 19.714 1 18.597 1 17.22V3.495C1 2.117 2.086 1 3.426 1H19.8c1.34 0 2.426 1.117 2.426 2.495V17.22z"}})])])
          )
        }
      }
    